import { useQueryState } from 'nuqs';

export const useGetSessionToken = () => {
  const [token, setToken] = useQueryState('token');

  return { token, setToken };
};
